import { createSlice } from '@reduxjs/toolkit';

interface IOrganizationSlice {
  orgId: string;
  expirationDateTime?: number;
}
export const organizationSlice = createSlice({
  name: 'organization',
  initialState: {
    orgId: '',
    expirationDateTime: undefined,
  } as IOrganizationSlice,
  reducers: {
    setOrgId: (state, action) => {
      state.orgId = action.payload;
    },
    setExpirationDateTime: (state, action) => {
      state.expirationDateTime = action.payload;
    },
  },
});

export const { setOrgId, setExpirationDateTime } = organizationSlice.actions;

export const { reducer: organizationReducer } = organizationSlice;
